import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { profileService } from "services/profileService";

const toMessage = (err, fallback) =>
  err?.response?.data?.message || err?.message || fallback;

export default function useServiceOfferings() {
  const [offerings, setOfferings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState({ totalElements: 0, totalPages: 1 });

  const list = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await profileService.organizations.services.list(params);
      const content = Array.isArray(res?.content) ? res.content : [];
      setOfferings(content);
      setPage({
        totalElements: res?.totalElements ?? content.length,
        totalPages: res?.totalPages ?? 1,
      });
      return res;
    } catch (err) {
      const message = toMessage(err, "Failed to load service offerings");
      setError(message);
      toast.error(message);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const create = useCallback(async (payload, actorId) => {
    try {
      const res = await profileService.organizations.services.create(payload, actorId);
      toast.success("Service offering created");
      return res;
    } catch (err) {
      toast.error(toMessage(err, "Failed to create service offering"));
      throw err;
    }
  }, []);

  const update = useCallback(async (id, payload, actorId) => {
    try {
      const res = await profileService.organizations.services.update(id, payload, actorId);
      toast.success("Service offering updated");
      return res;
    } catch (err) {
      toast.error(toMessage(err, "Failed to update service offering"));
      throw err;
    }
  }, []);

  const remove = useCallback(async (id, actorId) => {
    try {
      await profileService.organizations.services.delete(id, actorId);
      toast.success("Service offering removed");
    } catch (err) {
      toast.error(toMessage(err, "Failed to remove service offering"));
      throw err;
    }
  }, []);

  return { offerings, loading, error, page, list, create, update, remove };
}

